export default "__VITE_ASSET__BwgHMBmK__"